'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const displayedStyles = styled.css `
  left: ${({ positionX }) => positionX}px;
  top: ${({ positionY }) => positionY}px;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ variant }) => variant === 'fit-target' && 'width: 100%;'}
  visibility: visible;
  opacity: 1;
`;
const maxHeightStyles = styled.css `
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-y: auto;
`;
const Container = styled__default.default.div `
  display: block;
  position: ${({ disablePortalForOptions }) => (disablePortalForOptions ? 'fixed' : 'absolute')};
  visibility: hidden;
  border-radius: ${({ theme }) => theme.designTokens.overlayRadius};
  box-shadow: ${({ theme }) => theme.designTokens.overlayShadow};
  background: ${({ theme }) => theme.designTokens.overlayBackgroundColor};
  opacity: 0;
  z-index: ${({ theme }) => theme.zIndices.overlay};
  top: -1000px;
  left: -1000px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ maxHeight }) => maxHeight && maxHeightStyles}
  ${({ isDisplayed }) => isDisplayed && displayedStyles}
`;
const Styled = {
    Container,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
